import rules from "./rbac-rules";

const check = (rules, role, action, data) => {
  const roles = role;

  var permissions = role;
  roles.forEach((element) => {
    permissions = permissions.concat(rules[element.name]);
  });

  if (!permissions) {
    // role is not present in the rules
    return false;
  }
  var staticPermissions = [];
  permissions.forEach((element) => {
    staticPermissions = staticPermissions.concat(element.static);
  });
  if (staticPermissions && staticPermissions.includes(action)) {
    // static rule not provided for action
    return true;
  }

  var dynamicPermissions = [];
  permissions.forEach((element) => {
    dynamicPermissions = dynamicPermissions.concat(element.dynamic);
  });
  if (dynamicPermissions) {
    const permissionCondition = dynamicPermissions[action];
    if (!permissionCondition) {
      // dynamic rule not provided for action
      return false;
    }

    return permissionCondition(data);
  }
  return false;
};

const Can = (props) =>
  check(rules, props.role, props.perform, props.data)
    ? props.yes()
    : props.no();

Can.defaultProps = {
  yes: () => null,
  no: () => null,
};

export default Can;
